export const Api = {
    BASE_URL: "api.emis",
    DEV_BASE_URL: "https://api.moherstportal.gm",
    AUTH_URL: "",
    

};

